import React from "react";
import logoLightMode from '../../src/assets/header-light.png'
import logoDarkMode from '../../src/assets/header-dark.png'
import {useManageContext} from "../App";
import {Link} from "react-router-dom";
import {mdiChevronLeft} from "@mdi/js";
import Icon from "@mdi/react";

export default function Header({children, backUrl = null, title = null}: {
    children?: any,
    backUrl?: string | null,
    title?: string | null,
}) {

    const {isDarkMode} = useManageContext();

    return (
        <header className={"z-1 px-4 py-3 position-fixed top-0 w-100 limit-width border-bottom border-1 " + (isDarkMode ? 'bg-dark' : 'bg-light')}>
            <div className="d-flex justify-content-between align-items-center h-100">
                {backUrl
                    ? <Link to={backUrl} className="text-decoration-none fs-5">
                        <Icon className={backUrl === '#' ? 'text-muted' : 'text-primary'} path={mdiChevronLeft} size={1.5}/>
                    </Link>
                    :
                    <img src={isDarkMode ? logoDarkMode : logoLightMode} alt="CLOUDEX Tracking" style={{maxHeight: 35}}/>}
                {title && <h5 className="fw-light mb-0 fw-bold">{title}</h5>}
                {children}
            </div>
        </header>
    )
}